import { Users, Building, Palette, MessageSquareText } from "lucide-react";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { CtaWhatsApp } from "../components/Cta";
import { Reveal } from "../components/motion";
import OfferCard from "../components/OfferCard";
import { OFFERS, DELIVERY_DELAY } from "../config/site";

const USAGES = [
  { icon: Users, t: "Équipes & collaborateurs", d: "Commerciaux, serveurs, agents, coiffeurs : chaque membre de l'équipe a sa carte à son nom, avec le même design de marque." },
  { icon: Building, t: "Multi-établissements", d: "Restaurants, hôtels, agences : un design décliné par lieu, avec les liens propres à chaque établissement (avis, itinéraire, menu)." },
  { icon: Palette, t: "Déclinaisons graphiques", d: "Couleurs par service, par fonction ou par point de vente : votre identité reste cohérente, chaque carte reste unique." },
  { icon: MessageSquareText, t: "Accompagnement dédié", d: "Un interlocuteur unique sur WhatsApp, du brief à la livraison, avec aperçus validés à chaque étape." },
];

export default function Packs() {
  const pack4 = OFFERS.find((o) => o.id === "pack4");
  const custom = OFFERS.find((o) => o.id === "sur-mesure");

  return (
    <>
      <Seo
        title="Packs personnalisés — Équipes & établissements"
        description="Packs de cartes digitales Noveocard pour équipes, collaborateurs et établissements : pack 4 cartes à 80 € TTC et packs sur mesure. Réponse sous 30 minutes sur WhatsApp."
        path="/packs-personnalises"
      />

      <PageHero
        dark
        eyebrow="Packs personnalisés"
        titleLines={["Une marque.", "Des dizaines de gestes."]}
        description="Équipez vos collaborateurs, vos établissements ou toute votre entreprise de cartes digitales cohérentes et personnalisées. Du pack de 4 cartes aux volumes sur mesure."
      >
        <CtaWhatsApp
          label="Nous contacter sur WhatsApp"
          message={custom.message}
          showResponseTime
          testid="packs-hero-cta"
        />
      </PageHero>

      <section className="bg-white py-20 sm:py-28">
        <div className="container-nv">
          <div className="grid gap-6 lg:grid-cols-2">
            <OfferCard offer={pack4} />
            <OfferCard offer={custom} delay={0.08} />
          </div>
          <Reveal className="mt-8 text-center">
            <p className="text-sm text-steel">
              {DELIVERY_DELAY} Prix affichés TTC. Pour les volumes importants, le tarif est étudié
              ensemble, sur mesure — toujours sans mauvaise surprise.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-brume py-20 sm:py-24">
        <div className="container-nv">
          <Reveal className="max-w-2xl">
            <p className="eyebrow">Pensé pour s'adapter</p>
            <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-nuit-900 sm:text-4xl">
              Chaque pack est construit avec vous.
            </h2>
          </Reveal>
          <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {USAGES.map((u, i) => (
              <Reveal key={u.t} delay={i * 0.08}>
                <article className="h-full rounded-3xl border border-nuit-900/10 bg-white p-6">
                  <u.icon className="h-6 w-6 text-electric" />
                  <h3 className="mt-4 font-display text-base font-bold text-nuit-900">{u.t}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-steel">{u.d}</p>
                </article>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-12 text-center">
            <CtaWhatsApp
              size="lg"
              message="Bonjour Noveocard, je souhaite un pack personnalisé de cartes digitales (équipe / établissements). Voici mon besoin :"
              showResponseTime
              testid="packs-bottom-cta"
            />
          </Reveal>
        </div>
      </section>
    </>
  );
}
